import { render, staticRenderFns } from "./SignUpCongrats.vue?vue&type=template&id=7363c5a8&scoped=true"
import script from "./SignUpCongrats.vue?vue&type=script&lang=js"
export * from "./SignUpCongrats.vue?vue&type=script&lang=js"
import style0 from "./SignUpCongrats.vue?vue&type=style&index=0&id=7363c5a8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7363c5a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7363c5a8')) {
      api.createRecord('7363c5a8', component.options)
    } else {
      api.reload('7363c5a8', component.options)
    }
    module.hot.accept("./SignUpCongrats.vue?vue&type=template&id=7363c5a8&scoped=true", function () {
      api.rerender('7363c5a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sections/SignUpCongrats.vue"
export default component.exports